import { useEffect, useMemo, useState } from 'react';
import { useCurrentError } from '@components/store/getters';
import { dappStore } from '../../store';
import {
  CloseIconContainer,
  Container,
  ErrorMessage,
  ErrorMessageLink,
  ErrorTitle,
  IconAndTitleContainer,
  StyledAlertIcon,
  StyledCloseIcon,
  TitleAndMessageContainer,
} from './ErrorBox.styles';

interface ErrorBoxProps {
  className?: string;
  hideCloseButton?: boolean;
}

export default function ErrorBox({ className, hideCloseButton }: ErrorBoxProps) {
  const [message, setMessage] = useState(false);
  const [showError, setShowError] = useState(true);
  const error = useCurrentError();

  const formatError = () => {
    if (error?.error == undefined && error?.message != undefined) {
      setMessage(error.message);
    } else if (
      error?.error != undefined &&
      error?.error?.data != undefined &&
      error?.error?.data?.message != undefined
    ) {
      // Error from Smart Contract
      const message = error.error.data.message.replace(
        'VM Exception while processing transaction: reverted with reason string',
        '',
      );
      setMessage(message);
    }
  };

  const closeError = () => {
    setShowError(false);
    dappStore.setState({ currentError: false });
  };

  useEffect(() => {
    setShowError(!!error);
    if (error) formatError();
  }, [error]);

  const errorMessage = useMemo(() => {
    if (error?.title?.includes('leverage')) {
      return (
        <ErrorMessage type="span">
          Follow us on{' '}
          <ErrorMessageLink href="https://twitter.com/ArchimedesFi" target="_blank">
            Twitter
          </ErrorMessageLink>{' '}
          and{' '}
          <ErrorMessageLink href="https://discord.gg/ehYcrTkb" target="_blank">
            Discord
          </ErrorMessageLink>{' '}
          for announcements on leverage availability.
        </ErrorMessage>
      );
    }
    return error?.message;
  }, [error]);

  return (
    <>
      {message && showError && (
        <Container className={className}>
          <IconAndTitleContainer>
            <StyledAlertIcon />
            <TitleAndMessageContainer>
              {error?.title && <ErrorTitle type="h3">{error?.title}</ErrorTitle>}
              <ErrorMessage type="span">{errorMessage}</ErrorMessage>
            </TitleAndMessageContainer>
          </IconAndTitleContainer>
          <CloseIconContainer onClick={closeError}>
            <StyledCloseIcon />
          </CloseIconContainer>
        </Container>
      )}
    </>
  );
}
